import { format } from './format';
import { groups } from './groups';

export type Offset = number | 'month' | '-month';

const getOffsetNumber = (offset?: Offset) => {
    if (!offset) return 0;

    if (typeof offset === 'number') return offset;

    switch (offset) {
        case 'month':
            return groups.month;
        case '-month':
            return -groups.month;
    }
};

export class CustomDate extends Date {
    public constructor(date?: number | 'now' | undefined, offset?: Offset) {
        let created: number;

        if (date === 'now' || date === undefined) created = new Date().getTime();
        else created = new Date(date).getTime();

        created += getOffsetNumber(offset);

        super(created);
    }

    public format = (toformat: string) => format(this.getTime(), toformat);
    // public toJs = () => toJs(this.getTime());
    public fromJs = () => this.getTime() / 1000;
    public firstWeekDay = () => new Date(this.getFullYear(), this.getMonth(), 1).getDay();
    public lastDay = () => new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
    public offset = (offset: Offset) => new CustomDate(this.getTime(), offset);
    public toGMT = () => new Date(this.getTime() + this.getTimezoneOffset() * 60 * 1000);
}
